export default __webpack_public_path__ + "static/media/img_si_con_03.94bede09.png";